import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import DatenschutzPage from "./pages/DatenschutzPage";
import ImpressumPage from "./pages/ImpressumPage";
import StudentPage from "./pages/StudentPage";
import TeacherPage from "./pages/TeacherPage";
import TeacherView from "./pages/TeacherView";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TeacherPage />} />
        <Route path="/liste/:id" element={<StudentPage />} />
        <Route path="/lehrer/:id/:secret" element={<TeacherView />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
